import React from 'react'

const VideosScreen = () => {
  return (
    <div>VideosScreen</div>
  )
}

export default VideosScreen